import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  TableCell,
  TableRow,
} from '@material-ui/core';

import i18n from '../../i18n';

import Dropdown from '../FormInput/Dropdown';

class EcommDataSpecialProjectRow extends Component {
  render() {
    const {
      canEdit,
      getTabIndex,
      handleSpecialProjectChange,
      locationData,
      specialProjectOptions,
    } = this.props;
    return (
      <TableRow>
        <TableCell
          key="specialProjectId"
          className="ecommTableLabel"
        >
          <Box fontSize="h5.fontSize" fontWeight="fontWeightBold">
            {i18n.t('location:specialProject').toUpperCase()}
          </Box>
        </TableCell>
        {Object.keys(locationData).map((element, index) => {
          const specialProjectClassName = locationData[element]
            .isSpecialProject
            ? 'studioDataRight ssenseLowWarning'
            : 'studioDataRight';
          return (
            <TableCell key={element} className={specialProjectClassName}>
              <Dropdown
                tabIndex={getTabIndex(index)}
                className="studioDataDropdown"
                value={
                  locationData[element].isSpecialProject
                    ? locationData[element].specialProjectId
                    : 0
                }
                name="specialProjectId"
                disabled={!canEdit}
                options={specialProjectOptions}
                onChange={event =>
                  handleSpecialProjectChange(event, element)
                }
              />
            </TableCell>
          );
        })}
      </TableRow>
    )
  }
}

EcommDataSpecialProjectRow.propTypes = {
  canEdit: PropTypes.bool.isRequired,
  getTabIndex: PropTypes.func.isRequired,
  handleSpecialProjectChange: PropTypes.func.isRequired,
  locationData: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.object, PropTypes.string])
  ).isRequired,
  specialProjectOptions: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array
  ]).isRequired,
}

export default EcommDataSpecialProjectRow;
